import { render, staticRenderFns } from "./InpatientReviewDx.vue?vue&type=template&id=20137c10&scoped=true&"
import script from "./InpatientReviewDx.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewDx.vue?vue&type=script&lang=js&"
import style0 from "./InpatientReviewDx.vue?vue&type=style&index=0&id=20137c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20137c10",
  null
  
)

export default component.exports